module.exports = __webpack_public_path__ + "static/media/Icon_Messages.e1167441.svg";